import React from "react";
import { SystemInfo } from "./types";

interface LockSystemDetailsProps {
  product: { system1: string };
  tableData: SystemInfo[];
}

const LockSystemDetails: React.FC<LockSystemDetailsProps> = ({ product, tableData }) => {
  const sys = product.system1.trim().toUpperCase();
  const details = tableData.length ? tableData.find((item) => item.system1 === product.system1) : undefined;
  // EPS i FPS nie mają daty ochrony patentowej - linia jest wtedy ukrywana
  const patentProtection = sys === "EPS" || sys === "FPS" ? "" : details?.patentprotection;
  return (
    <div>
      <div style={{ margin: "15px 30px 5px" }}>
        <strong>{details?.slogan}</strong>
      </div>
      <div style={{ margin: "5px 30px" }}>
        <strong>Produktvorteil:</strong> {details?.specialfeature}
      </div>
      {patentProtection && String(patentProtection).trim() && (
        <div style={{ margin: "5px 30px" }}>
          <strong>Patentschutz mind. bis:</strong> {patentProtection}
        </div>
      )}
    </div>
  );
};

export default LockSystemDetails;
